import React from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Typography} from '@pb/kit-component-typography';

import {StringFilterItem, SuggestionType} from '../typedefs';

type Props = {
    type: SuggestionType,
    items: StringFilterItem[],
};

export const EventCodeSuggestionGroup = ({type, items}: Props) => (
    <Group direction="v" gap="none">
        <Typography variant="caption-level-2" fontWeight="semi-bold" className="pl-m pt-s">{type}</Typography>
        {items.map(item => (
            <AutosuggestItem key={item.id} value={item} meta={item.source}>
                <EllipsisTextHint>{item.name}</EllipsisTextHint>
            </AutosuggestItem>
        ))}
    </Group>
);
